export default {"src":"/_next/static/media/icon_deposit_success_check_mark.a75db0ca.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};